import api from '../utils/api';

export const getGroupList = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/group/getallGroup`,
        method: "Post",
        data: data,
        ...options,
    });
}

export const deleteGroup = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/group/deleteGroup/${data}`,
        method: "DELETE",
        data: data,
        ...options,
    });
}

export const saveEditGroup = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/group/addUpdateGroup`,
        method: "POST",
        data: data,
        ...options,
    });
}


export const getPatientGroupById = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/group/getPatientGroupById`,
        method: "Post",
        data: data,
        ...options,
    });
}

export const deletePatientFromGroupById = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/group/deletePatienGroupById/${data}`,
        method: "DELETE",
        data: data,
        ...options,
    });
}


export const getPatientList = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/patient/getAllPatient`,
        method: "Post",
        data: data,
        ...options,
    });
}

export const savePatientsToGroup = (config = {}) => {
    const { options } = config;
    return api({
        url: '/api/group/addPatientToGroup',
        method: 'POST',
        ...options,
    });
};


export const GetAllLocation = (config = {}) => {
    const { options } = config;
    return api({
        url: '/api/location/getAllLocation',
        method: 'GET',
        ...options,
    });
};

export const getContactList = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/patient/getAllContacts`,
        method: "POST",
        data: data,
        ...options,
    });
}